export { default as PriceWithDiscount } from './PriceWithDiscount'



// WEBPACK FOOTER //
// ./src/components/priceWithDiscount/index.js